.header {
    display: flex;
    justify-content: space-between;
    padding: 16px 16px 8px 16px;
    border-bottom: 1px solid var(--off-white);
}
